var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-login", attrs: { id: "app" } },
    [
      _c("back-home"),
      _vm._v(" "),
      _c("header", [
        _c("img", {
          attrs: { src: _vm._f("protocolFixer")(_vm.config.logo), alt: "" }
        }),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.config.title))])
      ]),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "m-loginForm", attrs: { name: "loginForm" } },
        [
          _c("mini-tabs", {
            staticClass: "tabs",
            attrs: { tabs: _vm.loginTypes },
            model: {
              value: _vm.loginType,
              callback: function($$v) {
                _vm.loginType = $$v
              },
              expression: "loginType"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c("lg-selects", {
                staticClass: "select select-short",
                attrs: { selects: _vm.selects },
                model: {
                  value: _vm.area,
                  callback: function($$v) {
                    _vm.area = $$v
                  },
                  expression: "area"
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:required",
                    arg: "required"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:pattern",
                    value: _vm.phoneRegex,
                    expression: "phoneRegex",
                    arg: "pattern"
                  }
                ],
                staticClass: "input-short",
                attrs: {
                  type: "text",
                  placeholder: "请输入手机号",
                  name: "phone"
                },
                domProps: { value: _vm.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.phoneError
                ? _c("p", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.phoneError))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginType === "password",
                  expression: "loginType === 'password'"
                }
              ],
              staticClass: "item"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:required",
                    arg: "required"
                  }
                ],
                attrs: {
                  type: "password",
                  placeholder: "请输入密码",
                  name: "password"
                },
                domProps: { value: _vm.password },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.passwordError
                ? _c("p", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.passwordError))
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginType === "code",
                  expression: "loginType === 'code'"
                }
              ],
              staticClass: "item"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code,
                    expression: "code"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate:required",
                    arg: "required"
                  }
                ],
                attrs: {
                  type: "text",
                  placeholder: "请输入验证码",
                  name: "code"
                },
                domProps: { value: _vm.code },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btnWrap", attrs: { id: "captchaBox" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: { "z-disabled": _vm.verifyInvalid },
                      attrs: { type: "button", disabled: _vm.verifyInvalid }
                    },
                    [_vm._v(_vm._s(_vm.verifyTxt))]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.codeError
                ? _c("p", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.codeError))
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item item-left" }, [
            _c(
              "label",
              { staticClass: "checkbox", attrs: { for: "protocol" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.protocol,
                      expression: "protocol"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate:required",
                      arg: "required"
                    }
                  ],
                  attrs: { type: "checkbox", name: "protocol", id: "protocol" },
                  domProps: {
                    checked: Array.isArray(_vm.protocol)
                      ? _vm._i(_vm.protocol, null) > -1
                      : _vm.protocol
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.protocol,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.protocol = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.protocol = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.protocol = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", { staticClass: "icon-checkbox" }),
                _vm._v(" "),
                _vm._m(0)
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item f-cf" }, [
            _c(
              "button",
              {
                staticClass: "f-fl submitBtn",
                attrs: {
                  type: "submit",
                  disabled: _vm.formInvalid,
                  "data-action": "saTrack",
                  "data-event": "UnionLoginBtnClick",
                  "data-track-event-origin": "web"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [_vm._v("确认登录")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "linkWrap f-fr" }, [
              _c(
                "a",
                {
                  attrs: { href: "/backend/register/" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.goRegister($event)
                    }
                  }
                },
                [_vm._v("立即注册")]
              ),
              _vm._v("  |  "),
              _c(
                "a",
                {
                  attrs: { href: "/backend/reset/" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.goReset($event)
                    }
                  }
                },
                [_vm._v("忘记密码？")]
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("footer", [
        _c("p", { staticClass: "divide" }, [_vm._v("第三方账号登录")]),
        _vm._v(" "),
        _c("a", {
          staticClass: "icn icn-weixin",
          attrs: { href: _vm.weixinUri }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "icn icn-work-weixin",
          attrs: { href: "/partner/work-weixin/user/auth/" }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _vm._v("我已阅读并同意"),
      _c("a", { attrs: { href: "/protocol/staff/", target: "_blank" } }, [
        _vm._v("《用户注册协议》")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c40149d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c40149d6","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 324
// module chunks = 3